import {
  GRADE,
  SECTION,
} from '../../../../apis/admissions/admissions.interfaces';
import { TKeyValue } from '../../../../utils/commonInterfaces';

export const GRADE_OPTIONS: TKeyValue<string>[] = [
  { key: GRADE.ONE, value: 'Grade 1' },
  { key: GRADE.TWO, value: 'Grade 2' },
  { key: GRADE.THREE, value: 'Grade 3' },
  { key: GRADE.FOUR, value: 'Grade 4' },
  { key: GRADE.FIVE, value: 'Grade 5' },
  { key: GRADE.SIX, value: 'Grade 6' },
  { key: GRADE.SEVEN, value: 'Grade 7' },
  { key: GRADE.EIGHT, value: 'Grade 8' },
  { key: GRADE.NINE, value: 'Grade 9' },
  { key: GRADE.TEN, value: 'Grade 10' },
  { key: GRADE.ELEVEN, value: 'Grade 11' },
  { key: GRADE.TWELVE, value: 'Grade 12' },
];

export const SECTION_OPTIONS: TKeyValue<string>[] = [
  { key: SECTION.A, value: 'Section A' },
  { key: SECTION.B, value: 'Section B' },
  { key: SECTION.C, value: 'Section C' },
  { key: SECTION.D, value: 'Section D' },
  { key: SECTION.E, value: 'Section E' },
  { key: SECTION.F, value: 'Section F' },
];
